import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStagesEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	name: "stages-empty",
	viewBox: "0 0 218 300",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "pipeline",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M2.754,0 L203.324,0 C203.968,0 204.557,0.364 204.845,0.94 L217.619,26.46 C217.859,26.94 217.859,27.504 217.619,27.984 L204.845,53.504 C204.557,54.081 203.968,54.444 203.324,54.444 L2.754,54.444 C2.16446293,54.4439044 1.61701071,54.1385584 1.30716113,53.6370136 C0.997311554,53.1354688 0.969250602,52.5092478 1.233,51.982 L13.243,27.984 C13.483,27.504 13.483,26.94 13.243,26.461 L1.234,2.463 C0.969854609,1.93582726 0.997566531,1.30946039 1.30723544,0.807674528 C1.61690434,0.305888665 2.16435281,0.000268666595 2.754,0 Z",
						id: "Shape",
						fill: "#E1E1E1"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-path",
						fill: "#E1E1E1",
						x: 0,
						y: 61.389,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-path",
						fill: "#E1E1E1",
						x: 0,
						y: 122.778,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-path",
						fill: "#E1E1E1",
						x: 0,
						y: 184.167,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-path",
						fill: "#E1E1E1",
						x: 0,
						y: 245,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(6.813000, 68.194000)",
						id: "Rectangle-path",
						children: [/* @__PURE__ */ _jsx("rect", {
							fill: "#FFFFFF",
							x: 0,
							y: 0,
							width: 190.75,
							height: 40.833,
							rx: 3.403
						}), /* @__PURE__ */ _jsx("rect", {
							fill: "#1FB790",
							x: 6.813,
							y: 20.417,
							width: 40.875,
							height: 13.611,
							rx: 1.701
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(6.813000, 129.583000)",
						id: "Rectangle-path",
						children: [/* @__PURE__ */ _jsx("rect", {
							fill: "#FFFFFF",
							x: 0,
							y: 0,
							width: 190.75,
							height: 40.833,
							rx: 3.403
						}), /* @__PURE__ */ _jsx("rect", {
							fill: "#FFC900",
							x: 6.813,
							y: 20.417,
							width: 40.875,
							height: 13.611,
							rx: 1.701
						})]
					})
				]
			})
		})
	})
});
export default SvgStagesEmpty;
